const MAN_GARAGE_IMAGE = "/assets/pack-zero-franchise/man-garage.png";
const FRANCHISE_DISCOUNT_IMAGE = "/assets/pack-zero-franchise/franchise-discount.png";

export const FranchiseExplainer = () => {
  return (
    <section className="max-w-[1600px] mx-auto flex flex-col items-center gap-16 px-4 py-16 md:px-12 md:py-24 xl:flex-row xl:gap-[120px] xl:px-20 xl:py-16">
      <div className="order-1 flex w-full max-w-[475px] flex-col gap-6 text-[#0D0D0D] xl:order-2 text-left md:text-center xl:text-left ">
        <h2 className="text-[23px] font-bold leading-[1.2] md:text-[28px]">
          Après un pépin, vous payez
        </h2>
        <p className="text-[16px] leading-[1.6] md:text-[19px]">
          Que vous soyez jeune conducteur ou pilote aguerri, votre assurance laisse le plus souvent
          une partie des frais à votre charge&nbsp;: la franchise.
        </p>
        <p className="text-[23px] font-bold leading-[1.2] md:text-[28px]">
          Avec nous, <span className="bg-[#FFD100] px-0.5">c’est fini.</span>
        </p>
      </div>

      <div className="order-2 hidden shrink-0 items-center md:flex xl:order-1">
        <div className="h-[376px] w-[488px] overflow-hidden rounded-[32px]">
          <img
            src={MAN_GARAGE_IMAGE}
            alt="Homme dans un garage"
            className="h-full w-full object-cover"
          />
        </div>
        <img
          src={FRANCHISE_DISCOUNT_IMAGE}
          alt="Franchise à payer : 0€ remboursée avec Roole"
          width={794}
          height={1110}
          className="-ml-[124px] mt-4 h-[346px] w-auto"
        />
      </div>

      <img
        src={FRANCHISE_DISCOUNT_IMAGE}
        alt="Franchise à payer : 0€ remboursée avec Roole"
        width={794}
        height={1110}
        className="order-2 h-[346px] w-auto md:hidden"
      />
    </section>
  );
};
